var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state-main-container"},[_c('div',{staticClass:"empty-state-text-container"},[_c('h1',{staticClass:"mb-0"},[_vm._v("404")]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('knowledge.empty-state.title')))])]),_c('base-button',{attrs:{"text":_vm.$t('knowledge.empty-state.cta')},on:{"click":_vm.backToHome}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }